import { render, staticRenderFns } from "./mapPic.vue?vue&type=template&id=2610829e&scoped=true&"
import script from "./mapPic.vue?vue&type=script&lang=js&"
export * from "./mapPic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2610829e",
  null
  
)

export default component.exports